/**
 * @generated SignedSource<<2cabec6b1dd687370a0c7f3d4030619e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Logo_brand$data = {
  readonly id: string;
  readonly logoImage: {
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly " $fragmentType": "Logo_brand";
};
export type Logo_brand$key = {
  readonly " $data"?: Logo_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"Logo_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Logo_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageType",
      "kind": "LinkedField",
      "name": "logoImage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "2adae047ae72b9b1bbf2fb5d9c0511f0";

export default node;
